<script setup lang="ts">
defineProps({
    isStandalone: {
        type: Boolean,
        default: true
    },
    isColorInverted: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <div
        :class="
            !isStandalone ? 'p-2 md:p-4 bg-white rounded-2xl border-none' : ''
        "
        :style="isColorInverted ? 'color: #FFFFFF' : 'color: #2463eb'"
    >
        <svg
            viewBox="0 0 20 21"
            xmlns="http://www.w3.org/2000/svg"
            class="spinner"
        >
            <path
                d="M20 10.5C20 16.0228 15.5228 20.5 9.99999 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 9.99999 0.5C15.5228 0.5 20 4.97715 20 10.5ZM2 10.5C2 14.9183 5.58172 18.5 9.99999 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 9.99999 2.5C5.58172 2.5 2 6.08172 2 10.5Z"
                :fill="isColorInverted ? '#1D4FD7' : '#F1F5F9'"
            />
            <path
                d="M1.00002 10.5C0.447738 10.5 -0.00515648 10.0512 0.0499792 9.50167C0.173587 8.26973 0.525231 7.06845 1.08996 5.96011C1.8064 4.55401 2.84545 3.33744 4.12216 2.40985C5.39888 1.48227 6.87699 0.870012 8.43567 0.623141C9.66426 0.428552 10.9154 0.465335 12.1253 0.728467C12.6649 0.845839 12.9518 1.41526 12.7812 1.94052C12.6105 2.46577 12.0467 2.74656 11.5043 2.64272C10.5976 2.46915 9.66523 2.45333 8.74854 2.59852C7.5016 2.79601 6.3191 3.28582 5.29773 4.02788C4.27636 4.76995 3.44512 5.74322 2.87197 6.86809C2.45061 7.69506 2.17753 8.5867 2.06244 9.5026C1.99358 10.0506 1.5523 10.5 1.00002 10.5Z"
                fill="currentColor"
            />
        </svg>
    </div>
</template>

<style scoped>
@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.spinner{animation:spin 1s linear infinite}
</style>
